exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".expand[data-v-4fcb7ce3] {\n  max-height: auto;\n  -webkit-transition: all 3s ease-in-out;\n  -moz-transition: all 3s ease-in-out;\n  -ms-transition: all 3s ease-in-out;\n  -o-transition: all 3s ease-in-out;\n  transition: all 3s ease-in-out;\n}\n.expand.expanded[data-v-4fcb7ce3] {\n  max-height: 0px;\n}\n", ""]);

// exports
